import { Box, useTheme } from "@mui/material";
import { useEffect, useRef, useState } from "react";
// import { tokens } from "../../../../../theme";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Text from "../../../../../../../components/theme/text/Text";
import { tokens } from "../../../../../../../theme";

import AddIcon from '@mui/icons-material/Add';
import ButtonGroup from "../../../../../../../components/theme/buttons/ButtonGroup";
import Shbutton from "../../../../../../../components/theme/buttons/Shbutton";

import { useTranslation } from "react-i18next";
import MAddPickupCrate from "../../../../../../../components/global/Modals/MAddPickingCrate";
import ShDataGrid2 from "../../../../../../../components/theme/datagrid2/ShDataGrid2";
import ShLabel from "../../../../../../../components/theme/label/ShLabel";
import SidepanelLoader from "../../../../../../../components/theme/sidepanel2/SidepanelLoader";
import ShTextSkeleton from "../../../../../../../components/theme/skeleton/ShTextSkeleton";
import { useFindAllPickupCratesQuery } from "../../../../../../../newapi/warehouse/pickupCartSlice";
import { selectUserPermission } from "../../../../../../../newapi/user/authentication/authSlice";
import { UserPrivileges } from '../../../../../../../utils/permissions';
import { useSelector } from "react-redux";
import { generateColorFromTitle, generateIconColorFromTitle } from "../../../../../../../components/theme/TabView3/IconColorGenerator";
import { WarehousePickingCratesCard } from "../../../../../../../components/global/cards/settings/WarehousePickingResourcesCards";

const SpPickingCrateDetails = SidepanelLoader(() => import("../../../../../../../components/global/Sidepanels/SpPickingCrateDetails/SpPickingCrateDetails"));

const GridActions = (props, i18n) => {
    const theme = useTheme();
    
    const {t} = useTranslation();
    return (      
        <ButtonGroup version={2}>
            {props.hasCreatePermission && (
            <Shbutton 
                onClick={() => props.handleOpen(true)}
                className={"group-btn"} 
                color={theme.palette.mode === "dark" ? "blue" : "primary"} 
                variant="contained" 
                endIcon={<AddIcon/>}>{t("new_pickingcrate")}</Shbutton>
            )}
        </ButtonGroup>
    )
}


const gridOptions = {
    export:true,
    disableCustomActionsOnPhone: true,
    isSidepanel: true,
};


const PickingCrates = (props) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [isExtended,setIsExtended] = useState(false);
    const [spLoading, setSpLoading] = useState();

    const hasCreatePermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.PICKINGRESOURCE_MANAGE])
    );

    const [pickingCrateId, setPickingCrateId] = useState();
    const pickingCrateIdRef = useRef(pickingCrateId);
    
    const getCrateDetails = (params) => {
        if (!params) return;
    
        const newpickingCrateId = parseInt(params.row.id);
        // Only update state if the pickingCrateId has actually changed
        if (pickingCrateIdRef.current !== newpickingCrateId) {
            if(!spLoading) {
                setSpLoading(true);
            }
            setPickingCrateId(newpickingCrateId);
            pickingCrateIdRef.current = newpickingCrateId; // Update the ref to the new value
        }
        setIsExtended(true);
    };


    const [addModalOpen, setAddModalOpen] = useState(false);
    const addModal = {
        open: addModalOpen,
        setOpen: setAddModalOpen
    }

    const handleClose = () => {
        setAddModalOpen(false);
      };
    
    useEffect(() => {
        props.replaceView({
            ...props.config,
            gridOptions:gridOptions,
            mobileActions:<GridActions handleOpen={() => setAddModalOpen(true)} hasCreatePermission={hasCreatePermission}></GridActions>
        });

        return () => {
            // console.log("unmounting warehouse");
        }
    },[]);

    
    const columns = [
        {field: "barcode", headerName: t("barcode") , flex:2, cellClassName: "stream", renderCell : (cellValues) => {
            if(cellValues.row.skeleton) {
                return <ShTextSkeleton/>
            }

            return (
                <Text semibold>{cellValues.value}</Text>
            )
        }},

        {field: "description", headerName: t("size"), flex:1, renderCell : (cellValues) => {
            if(cellValues.row.skeleton) {
                return <ShTextSkeleton/>
            }
            let backGround = generateColorFromTitle(cellValues.row.containerSize?.description ?? "-", theme.palette.mode, 93)
            let foreGround = generateIconColorFromTitle(cellValues.row.containerSize?.description ?? "-", theme.palette.mode)

            return (
                <Box
                    sx={{
                        height:32,
                        px:2,
                        display:"flex",
                        alignItems:'center',
                        fontFamily:"Roboto, sans-serif",
                        fontSize:14,
                        border:`1px solid ${foreGround}`,
                        color:foreGround,
                        background:backGround,
                        borderRadius:4,
                        fontWeight:500,
                    }}
                >
                    {cellValues.row.containerSize?.description}
                </Box>
            )
        }},
        {field: "length", headerName: t("dimensions_lwh"), flex:1, renderCell : (cellValues) => {
            if(cellValues.row.skeleton) {
                return <ShTextSkeleton/>
            }

            return (
                <Text>{`${cellValues.row.containerSize?.length} x ${cellValues.row.containerSize?.width} x ${cellValues.row.containerSize?.height}`}</Text>
            )
        }},
        {field: "volume", headerName: t("volume"), flex:1, renderCell : (cellValues) => {
            if(cellValues.row.skeleton) {
                return <ShTextSkeleton/>
            }

            return (
                <>
                    <Text sx={{marginRight:0.5}}>{cellValues.row.containerSize?.volume}</Text>
                    <Text light>{t("mm3")}</Text>
                </>
            )
        }},
        {
            field: "phoneView", 
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            renderCell: (cellValues) => {
                if(cellValues.row.skeleton) {
                    return <ShTextSkeleton/>
                }

               return (
                    <WarehousePickingCratesCard 
                        skeleton={cellValues.row.skeleton ?? false}
                        onClick={() => getCrateDetails(cellValues)}
                        {...cellValues.row}
                    />
               )
            }
        }
    ];

    return (
        <Box
            sx={{
                height:1,
                "@media screen and (max-width: 47.9375em)" : {
                    paddingTop:0,
                    paddingX:0,
                }
            }}
        >
            <ShDataGrid2 key={theme.palette.mode}
                content={useFindAllPickupCratesQuery}
                gridActions={<GridActions handleOpen={() => setAddModalOpen(true)} hasCreatePermission={hasCreatePermission}></GridActions>} 
                title={t("overview")}
                gridOptions={gridOptions} 
                columns={columns}
                sortModel={{field: columns[0].field,type:"ASC"}}
                onRowClick={getCrateDetails}>
            </ShDataGrid2>

            <MAddPickupCrate onOpen={() => addModal.setOpen(true)} onClose={() => addModal.setOpen(false)} open={addModal.open} handleClose={handleClose}/>
            {spLoading && 
                <SpPickingCrateDetails
                    isExtended={isExtended}
                    setIsExtended={setIsExtended}
                    pickingCrateId={pickingCrateId}
                    // data={crateData}   
                /> 
            }
        </Box>
    )
};


export default PickingCrates;